/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { getCheckFile, getUrl } from '../viewer/type/viewer-type-util';

/**
 * @import { FileSystemMapper } from '../file/system'
 * @import { ViewerSourceCreator } from '../viewer/source'
 * @import BasePathResolver from '../basepath/basepath'
 * @import ImageViewerControllerFactory from './image-viewer-controller-factory'
 * @import { ViewerType } from '../viewer/type'
 */

/**
 * Typ média obrázek s podporou přehrávání v offline stavu pomocí `file://` URL.
 * Obrázek se stáhne z URL v síti a pak se zobrazuje z lokálního úložiště.
 * Díky tomu lze obrázek zobrazovat v online i offline stavu.
 * @implements {ViewerType}
 */
export default class ImageFileViewerType {
  /**
   * Vytvoří instanci.
   * @param {BasePathResolver} basePathResolver
   * @param {ImageViewerControllerFactory} controllerFactory
   * @param {FileSystemMapper} pathMapper
   * @param {ViewerSourceCreator<HTMLDivElement>} sourceCreator
   */
  constructor(basePathResolver, controllerFactory, pathMapper, sourceCreator) {
    this.basePathResolver = basePathResolver;
    this.controllerFactory = controllerFactory;
    this.pathMapper = pathMapper;
    this.sourceCreator = sourceCreator;
  }

  /** @type {ViewerType['createController']} */
  createController(el, communicatorSettingsGetter) {
    return this.controllerFactory.create(el, communicatorSettingsGetter);
  }

  /** @type {ViewerType['getCheckFile']} */
  getCheckFile(medium) {
    return getCheckFile(medium);
  }

  /** @type {ViewerType['getSourceCreator']} */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @type {ViewerType['getUrl']} */
  getUrl(medium) {
    return getUrl(this.basePathResolver, medium, this.pathMapper);
  }

  /** @type {ViewerType['isExtractable']} */
  isExtractable() {
    return false;
  }

  /** @type {ViewerType['isOfflineable']} */
  isOfflineable() {
    return true;
  }

  /** @type {ViewerType['isPreloadable']} */
  isPreloadable(medium) {
    return true;
  }

  /** @type {ViewerType['isSeekable']} */
  isSeekable(medium) {
    return false;
  }

  /** @type {ViewerType['isStatic']} */
  isStatic(medium) {
    if (medium.type === 'image/gif') {
      return false;
    }
    return true;
  }
}
